import React from 'react';
import { useTranslation } from "react-i18next";
import { logoLight } from "../../assets/images";

const WelcomeBanner = () => {
  const { t } = useTranslation();

  const handleDownload = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /ipad|iphone|ipod/.test(userAgent);

    if (isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.alshrif.kyan';
    } else if (isIOS) {
      window.location.href = 'https://apps.apple.com/eg/app/%D9%83%D9%8A%D8%A7%D9%86-%D9%85%D8%A7%D8%B1%D9%83%D8%AA/id6740716241';
    } else {
      // If not mobile, default to Play Store
      window.location.href = 'https://play.google.com/store/apps/details?id=com.alshrif.kyan';
    }
  };

  return (
    <section className="p-4 sm:p-6 md:p-8 ">

      <div className="flex justify-center">
        <div className="w-full">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 sm:p-8 md:p-10  border border-gray-100">
            <div className="flex flex-col items-center space-y-6 md:space-y-0 md:flex-row md:justify-between">
              <div className="flex flex-col items-center md:flex-row md:items-center space-y-4 md:space-y-0">
                <img
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  src={logoLight}
                  alt="Kayan Store Logo"
                  className="h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 object-contain"
                />

                <div className="text-center md:text-left md:ml-8">
                  <h1 className="text-3xl sm:text-4xl text-[#004aad] font-bold mb-3 tracking-tight">
                    {t("home.Welcome_toـKayanـStore")}
                  </h1>
                  <p className="text-[#4B587C] text-base sm:text-lg max-w-xl">
                    {t("home.Downloadـtheـappـtoـgetـfreeـfood")}
                  </p>
                </div>
              </div>

              <button
                onClick={handleDownload}
                className="inline-block bg-gradient-to-r from-[#f7931e] to-[#FF8000] text-white px-8 py-4 rounded-xl 
                    hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 text-lg font-semibold"
              >
                {t("home.Download_Now")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeBanner;